export default "__VITE_ASSET__Fc_iqHqj__"